import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);


export default function createStore(superDefaultState) {

    return new Vuex.Store({

        state: Object.assign(
                {
                    user: null,
                    loginInProfile: null,
                    timezone: 'UTC',
                    layout: 'defaultLayout',
                    apiResponse: {},
                    employeeProfileId:null,
                }, superDefaultState
                ),
        getters: {
            getApiResponse: state => endpoint => {
                    return state.apiResponse[endpoint + ''] ? state.apiResponse[endpoint + ''] : null;
                },
            isLoggedIn(state) {
                return state.user ? true : false;
            },
          getLoginInProfile(state) {
                return state.loginInProfile ? state.loginInProfile : false;
            },
            layout(state) {
                return state.layout
            },
            timezone(state) {
                return state.timezone
            },
            getUser(state) {
                // return state.user;
                return state.user|| JSON.parse(localStorage.getItem('user'));
            },

            getrole(state){

            },
            getSelectedCompany(state) {

                if (state.user && state.user.type == 'EMPLOYEE') {
                    state.user.company['is_selected'] = 1;
                    state.user.companies.push(state.user.company);
                    // state.user && (state.user.company =='')? state.user.company : [];
                }
                return state.user && (state.user.companies !='')? state.user.companies.find(x => x.is_selected == 1) : [];
            },
            getEmployeeProfileId(state){
              var data = localStorage.getItem('profileData');
              return state.employeeProfileId || JSON.parse(data);
            }
        },
        mutations: {
            initialiseStore(state) {
                let localStorageUser = localStorage.getItem("user") || null;
                if (localStorageUser) {
                    state.user = JSON.parse(localStorageUser);
                }
                state.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                cookies.set('timezone', state.timezone);
            },
            setApiResponse(state, data) {
                return state.apiResponse[data.key] = data.data
            },
            deleteApiResponse(state, key) {
                delete state.apiResponse[key + ''];
            },
            SET_LAYOUT(state, payload) {
                state.layout = payload
            },
            setUser(state, user) {
                state.user = Object.assign(state.user || {}, user);
                localStorage.setItem('user', JSON.stringify(state.user));
            },
          setLoginInProfile(state, user) {
                state.loginInProfile = user;
            },
            logoutUser(state){
              state.user = null;
              localStorage.removeItem('user');
              localStorage.removeItem('profileData');
            },
            setEmployeeProfileId(state,id){
              state.employeeProfileId = Object.assign(state.employeeProfileId || {}, id);
              localStorage.setItem('profileData', JSON.stringify(id));
            }
        },
        actions: {
        }

    })
}
